import React, { useState } from "react";
import Modal from "../Modal";

const IdeaRejectModal = ({ idea, onClose, onSubmit, submitting = false }) => {
  const [feedback, setFeedback] = useState("");
  const trimmed = feedback.trim();

  if (!idea) return null;

  return (
    <Modal onClose={onClose} maxWidth="max-w-lg" heightClass="h-auto max-h-[90vh]">
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-theme-text">Reject this idea</h3>
          <p className="text-sm text-theme-text opacity-70 mt-1">
            Share what missed the mark so future ideas can improve.
          </p>
        </div>

        <div className="rounded-lg border border-theme-secondary bg-theme-secondary p-3">
          <p className="text-sm font-medium text-theme-text">{idea.title || "Untitled idea"}</p>
          {idea.content ? (
            <p className="text-sm text-theme-text opacity-70 mt-1 line-clamp-3">{idea.content}</p>
          ) : null}
        </div>

        <div>
          <label htmlFor="idea-rejection-feedback" className="block text-sm font-medium text-theme-text mb-2">
            Constructive feedback
          </label>
          <textarea
            id="idea-rejection-feedback"
            rows={4}
            value={feedback}
            onChange={(event) => setFeedback(event.target.value)}
            placeholder="e.g. Too product-heavy, hook feels generic, wrong audience tone..."
            className="w-full px-3 py-2 rounded-lg border border-theme-secondary bg-theme-main text-theme-text text-sm placeholder-theme-text placeholder-opacity-50 resize-none focus:outline-none focus:ring-2 focus:ring-theme-primary"
          />
        </div>

        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="px-4 py-2 rounded-md border border-theme-secondary text-sm text-theme-text hover:bg-theme-secondary disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onSubmit?.(trimmed)}
            disabled={!trimmed || submitting}
            className="px-4 py-2 rounded-md bg-theme-primary text-theme-button text-sm font-medium hover:opacity-90 disabled:opacity-50"
          >
            {submitting ? "Saving..." : "Reject idea"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default IdeaRejectModal;
